module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m10-2679b13aed4245f6966b892722a10a2c.png";